import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { styled } from '@mui/material'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import React from 'react'

export type Props = Omit<AccordionProps, 'title'> &
  React.HTMLAttributes<HTMLDivElement> & {
    display?: boolean
    placeholder: React.ReactNode
    title: React.ReactNode
  }

const Accordion = React.forwardRef<HTMLDivElement, Props>(
  ({ children, title, placeholder, display = false, ...props }, ref) => {
    const [expanded, setExpanded] = React.useState<boolean>(display)

    return (
      <StyledAccordion {...props} ref={ref} expanded={expanded} onChange={(_, isExpanded) => setExpanded(isExpanded)}>
        <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{!expanded ? placeholder : title}</Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>{children}</StyledAccordionDetails>
      </StyledAccordion>
    )
  },
)

const StyledAccordion = styled(MuiAccordion)({
  borderRadius: '2px',
  margin: '0px',
  transform: 'translate3d(0, 0, 0)',
})

const StyledAccordionSummary = styled(AccordionSummary)({
  backgroundColor: 'rgb(245, 245, 245)',
})

const StyledAccordionDetails = styled(AccordionDetails)({
  width: '100%',
  display: 'block',
})

export default Accordion
